import { render, staticRenderFns } from "./node-udf.vue?vue&type=template&id=a30c2e1a"
import script from "./node-udf.vue?vue&type=script&lang=js"
export * from "./node-udf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports